import { ViewSheqManager } from "./components/ViewSheqManager";

export default ViewSheqManager;